import React, { useState } from 'react';
import api from '../api';
import { FaTimes, FaFileUpload, FaDownload } from 'react-icons/fa';
import { theme, t } from '../theme';
import { entregarArquivo } from '../platform/arquivos';

const ProductImport = ({ fecharModal }) => {
    const [file, setFile] = useState(null);
    const [importando, setImportando] = useState(false);
    const [erro, setErro] = useState(null);
    const [resultado, setResultado] = useState(null);

    const handleFileChange = (e) => setFile(e.target.files[0]);

    const handleUpload = async () => {
        if (!file) { setErro('Selecione um arquivo Excel/CSV.'); return; }
        setErro(null); setResultado(null);
        const formData = new FormData();
        formData.append('file', file);
        try {
            setImportando(true);
            const res = await api.post('/produtos/importar', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            setResultado(res.data);
        } catch (err) {
            setErro(err.response?.data?.erro || 'Erro ao importar. Verifique o arquivo.');
        } finally { setImportando(false); }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {erro && <div style={t.error}>{erro}</div>}
            {resultado && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <div style={t.success}>
                        ✅ {resultado.produtos_importados} ingrediente(s) importado(s) com sucesso
                    </div>
                    {resultado.produtos_ignorados > 0 && (
                        <div style={{
                            background: theme.colors.warningLight || '#FEF3C7',
                            border: `1px solid ${theme.colors.warning || '#F59E0B'}`,
                            borderRadius: 8, padding: '12px 14px', fontSize: 13,
                        }}>
                            <div style={{ fontWeight: 600, color: theme.colors.warning || '#B45309', marginBottom: 8 }}>
                                ⚠️ {resultado.produtos_ignorados} linha(s) ignorada(s)
                            </div>
                            {Array.isArray(resultado.erros_por_linha) && resultado.erros_por_linha.length > 0 && (
                                <div style={{ maxHeight: 220, overflowY: 'auto' }}>
                                    <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: theme.colors.textSecondary, textAlign: 'left' }}>
                                                <th style={{ padding: '4px 6px', width: 50 }}>Linha</th>
                                                <th style={{ padding: '4px 6px' }}>Nome</th>
                                                <th style={{ padding: '4px 6px' }}>Motivo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resultado.erros_por_linha.map((e, i) => (
                                                <tr key={i} style={{ borderTop: `1px solid ${theme.colors.warning || '#F59E0B'}40` }}>
                                                    <td style={{ padding: '6px', fontWeight: 600 }}>{e.linha}</td>
                                                    <td style={{ padding: '6px', wordBreak: 'break-word' }}>{e.nome}</td>
                                                    <td style={{ padding: '6px', color: theme.colors.text }}>{e.motivo}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            <div style={{ marginTop: 8, fontSize: 11, color: theme.colors.textSecondary }}>
                                Corrija essas linhas na planilha e envie novamente — só as ignoradas serão processadas.
                            </div>
                        </div>
                    )}
                    <div>
                        <button onClick={() => { setResultado(null); if (fecharModal) fecharModal(); }} style={{ ...t.btnPrimary, fontSize: 12, padding: '6px 14px' }}>Fechar</button>
                    </div>
                </div>
            )}

            <div style={{ background: theme.colors.bgSection || '#F9FAFB', border: `1px solid ${theme.colors.border}`, borderRadius: 8, padding: 12, fontSize: 12, color: theme.colors.textSecondary, lineHeight: 1.6 }}>
                <strong style={{ color: theme.colors.text }}>📋 Como preencher a planilha</strong>
                <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
                    <li><strong>nome</strong> — único campo obrigatório.</li>
                    <li><strong>controlar_estoque</strong> — TRUE ou FALSE. Se FALSE, ignora código de barras, estoque mínimo e estoque inicial.</li>
                    <li><strong>unidade_peso</strong> — kg, l, unidade ou caixa.</li>
                    <li><strong>peso_embalagem</strong> — peso da embalagem que você compra (ex: 1 = 1 kg).</li>
                    <li><strong>custo_medio</strong> — preço médio pago por embalagem (R$).</li>
                    <li><strong>estoque_inicial</strong> — quantidade que você já tem (cria lote "INICIAL" com validade de 1 ano).</li>
                </ul>
            </div>

            <button onClick={async () => {
                try {
                    const res = await api.get('/produtos/template-importacao', { responseType: 'blob' });
                    await entregarArquivo(res.data, 'modelo_importacao_ingredientes.xlsx');
                } catch { setErro('Erro ao baixar modelo.'); }
            }} style={{ ...t.btnSecondary, justifyContent: 'center', width: '100%' }}>
                <FaDownload size={13} /> Baixar Modelo de Importação
            </button>

            <div>
                <label style={t.label}>Arquivo Excel ou CSV</label>
                <input type="file" accept=".xlsx,.csv" onChange={handleFileChange}
                    style={{ ...t.input, padding: '8px 12px', cursor: 'pointer' }} />
                {file && <p style={{ fontSize: 13, color: theme.colors.success, marginTop: 4 }}>{file.name}</p>}
            </div>

            <button onClick={handleUpload} disabled={importando}
                style={{ ...t.btnPrimary, justifyContent: 'center', width: '100%', opacity: importando ? 0.6 : 1 }}>
                <FaFileUpload size={14} /> {importando ? 'Importando...' : 'Enviar'}
            </button>
        </div>
    );
};

export default ProductImport;
